import React, { useState, useMemo, useEffect } from 'react'
// import ButtonCustom from '../atoms/button/ButtonCustom'
import InputCustom from '../atoms/input/InputCustom'
import PriceRange from '../atoms/price-range/PriceRange'
// import SelectCustom from '../atoms/select/SelectCustom'
import SwitchBtn from '../atoms/switch-btn/SwicthBtn'
import styles from './venderListStyle.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import {
	getVendorFieldValues,
	setVendorFilters,
} from '../../features/vendorSlice'
import { useDebouncedCallback } from '../../hooks'
import { ALL_STACKS, profilePics } from '../../util/constants'
import MultiselectSearch from '../atoms/select/MultiSelect'
import { OTHER_TYPE_TOKEN } from '../../util/constants'
import LocationDropdown from './LocationDropdown'


/** TODO:: As per Karen Doc (https://docs.google.com/document/d/1mQbJWHH63TNaksfGe4aTLPPqNhz05aeUnmtyAoAToao/edit?tab=t.0#heading=h.g5wlmj4prc9m)
 * let's discuss which we need to add in the filter form.
 *
 * Category: Photography, Venue, Florist, etc.
 * Subcategory (if applicable): e.g. “DJ” or “Live Band.”
 * Budget Range: slider / min-max input.
 * Location: City, postal code + radius filter.
 * Availability: date picker linked to wedding date(s).
 * Reviews / Ratings: 4★ & up, 3★ & up.
 * Services Offered: checkboxes (e.g., Second Shooter, Travel Included).
 * Response Time / Average Lead Time.
 */

const FilterForm = ({ clear }) => {
	const dispatch = useDispatch()
	const vendorFilters = useSelector((state) => state.vendor.vendorFilters)
	const fields = useSelector((state) => state.vendor.vendorFieldValues)
	const customBusinessType = fields?.customBusinessType ?? []
	const businessTypes = fields?.businessTypes ?? fields?.businessType ?? []
	// const addresses = useSelector(
	// 	(state) => state.vendor.vendorFieldValues?.['businessAddress']
	// )
	const [data, setData] = useState({
		lowerPriceRange: 0,
		upperPriceRange: 500000,
	})
	const [types, setTypes] = useState([])

	const stacks = useMemo(() => {
		if (!businessTypes?.length) return []

		const normalized = businessTypes
			.map((t) => (typeof t === 'string' ? t.trim() : ''))
			.filter(Boolean)

		const customTypes = [...new Set(normalized)].filter(
			(t) => !ALL_STACKS.includes(t)
		)

		const base = ALL_STACKS.map((name, i) => ({
			_id: `stack-${i}`,
			name,
			value: name,
			profilePic:
				profilePics[i] ||
				'/images/ontimebride_iconset_blue_vendor_default.png',
		}))

		if (!customTypes?.length && !customBusinessType?.length) return base

		return [
			...base,
			{
				_id: 'other',
				name: 'Other',
				value: [
					...new Set([
						...customBusinessType,
						...customTypes,
						OTHER_TYPE_TOKEN,
					]),
				],
				profilePic:
					'/images/ontimebride_iconset_blue_vendor_default.png',
			},
		]
	}, [businessTypes, customBusinessType])

	// const addressesList = useMemo(() => {
	// 	if (!addresses?.length) return []
	// 	return [...new Set(addresses)].map((v) => ({
	// 		label: v,
	// 		value: v,
	// 	}))
	// }, [addresses])

	const handleChange = (k, v) =>
		dispatch(setVendorFilters({ ...vendorFilters, page: 1, limit: 10, [k]: v }))

	const debouncePriceRange = useDebouncedCallback((lower, upper) => {
		dispatch(
			setVendorFilters({
				...vendorFilters,
				page: 1,
				limit: 10,
				lowerPriceRange: lower,
				upperPriceRange: upper,
			})
		)
	}, 1000)

	const handleMultiSelect = (v) =>
		setTypes((prev) => {
			const exists = prev.some((item) => item._id === v._id)
			if (exists) return prev
			return [...prev, v]
		})

	const handleMultiRemove = (v) => {
		setTypes((prev) => prev.filter((x) => x._id !== v))
	}

	useEffect(() => {
		if (types.length > 0) {
			const typeString = types
				.flatMap((t) => {
					const v = t.value ?? t.name
					return Array.isArray(v) ? v : [v]
				})
				.join(',')
			handleChange('types', typeString)
		} else handleChange('types', '')
	}, [types])

	useEffect(() => {
		if (clear) {
			setData({
				lowerPriceRange: 0,
				upperPriceRange: 500000,
			})
			setTypes([])
		}
	}, [clear])

	useEffect(() => {
		dispatch(setVendorFilters({}))
		dispatch(getVendorFieldValues({ fieldName: 'businessType' }))
		// dispatch(getVendorFieldValues({ fieldName: 'businessAddress' }))
		dispatch(getVendorFieldValues({ fieldName: 'customBusinessType' }))
	}, [dispatch])

	return (
		<form action="">
			<div className={styles.formGroup}>
				<label htmlFor="type" className={styles.formLabel}>
					Type
				</label>
				<MultiselectSearch
					members={stacks}
					selected={types}
					onSelect={handleMultiSelect}
					onRemove={handleMultiRemove}
					placeholder="Select a type"
					searchPlaceholder="Search a type..."
				/>
			</div>
			<div className={styles.formGroup}>
				<label htmlFor="Location" className={styles.formLabel}>
					Location
				</label>
				<LocationDropdown
					value={vendorFilters?.businessAddress || ''}
					onChange={(val) => handleChange('businessAddress', val)}
				/>
			</div>

			{/* TODO: uncomment when confirmed functionality with Karen */}
			{/*<div className={styles.formGroup}>
				<label htmlFor="Date" className={styles.formLabel}>
					Date
				</label>

				<InputCustom type="date" name="date" />
			</div>
			<div className={styles.formGroup}>
				<label htmlFor="Time" className={styles.formLabel}>
					Time
				</label>

				<InputCustom type="time" name="Time" />
			</div>
			<div className={styles.formGroup}>
				<SwitchBtn
					onClick={() => console.log('clicked')}
					label="All Day"
					size="lg"
					labelColor={'#313131'}
					className={styles.switchBtn}
				/>
			</div> */}
			<div className={styles.formGroup}>
				<label htmlFor="PriceRange" className={styles.formLabel}>
					Price Range
				</label>
				<PriceRange
					userDetails={data}
					setUserDetails={(v) => {
						setData(v)
						debouncePriceRange(v.lowerPriceRange, v.upperPriceRange)
					}}
				/>
			</div>
		</form>
	)
}

export default FilterForm
